import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

type UpdateNotificationProps = {
  open: boolean;
  onUpdate: () => void;
  onClose: () => void;
};

const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  open,
  onUpdate,
  onClose
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={onClose}
      autoHideDuration={null}
    >
      <Alert
        severity="info"
        onClose={onClose}
        action={
          <Button color="inherit" size="small" onClick={onUpdate}>
            Update
          </Button>
        }
      >
        A new version is available. Update now?
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification;
